import { render, staticRenderFns } from "./RouterFormDialog.vue?vue&type=template&id=1b341c44"
import script from "./RouterFormDialog.vue?vue&type=script&lang=ts"
export * from "./RouterFormDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports